<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div align="center">
      <p>确定删除商品信息</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDeleteProductModel">点错了</el-button>
      <el-button type="primary" @click="deleteProduct">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteProduct } from '@/api/goods/productApi'

export default {
  name: 'DeleteProduct',
  data() {
    return {
      dialogVisible: false,
      deleteProductInfo: {}
    }
  },
  methods: {
    open(product) {
      this.deleteProductInfo = product
      this.dialogVisible = true
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    closeDeleteProductModel() {
      this.dialogVisible = false
    },
    async deleteProduct() {
      try {
        const res = await deleteProduct(this.deleteProductInfo)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error('删除失败')
      }
    }
  }
}
</script>